import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/warehouse-circulation-report`;

export const warehouseCirculationReportManagementRoutesObj = {
  list: baseRoute,
  // TODO: ADD VIEW INVOICE AND DEBT PAYMENT PAGES LATER
} as const;

export type IWarehouseCirculationReportRouteParams = IExtractRouteParamMap<
  typeof warehouseCirculationReportManagementRoutesObj
>;

export const warehouseCirculationReportManagementPath = createPaths<
  typeof warehouseCirculationReportManagementRoutesObj,
  IWarehouseCirculationReportRouteParams
>(warehouseCirculationReportManagementRoutesObj);
